import styled from "styled-components";
import { Container, Store, wrap, Wrapper } from 'AppReact';
import { InputError, Input } from 'molecules';
import { FieldWrapper } from './../../../common/wrappers';
import device from "utils/device";
import { switchLabel } from './../../../utilities';
import { GoogleSearchInput } from './../../../common/molecules';
import { showAddressFields } from "../../../utils";
import { US_STATES } from "utils/statesCodeOptions";
import { Dropdown } from 'containers';

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`
const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);
const WrappedGoogleSearchInput = wrap(GoogleSearchInput, FieldWrapper);
const WrappedDropdown = wrap(Dropdown, FieldWrapper);

export const definition = {
    name: "Landlord",
    props: { isEditMode: Store, property: Store, currentResidency: Store, selectedTabId: Store, language: Store  },
    elements: [
        {
            wrapper: Wrapper(template),
            name: "Wrapper",
            elements: [
                {
                    componentSelect: switchLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${language?.prev_residences || 'Current Residency'}`,
                    bindings: ({ selectedTabId }) => selectedTabId
                },
                {
                    component: WrappedInput,
                    name: 'Address',
                    renderIf:({ isEditMode, currentResidency }) => !currentResidency?.address?.hasOwnProperty('address') && isEditMode,
                    bindings: ({ language, currentResidency }) => 
                            ({ currentResidency, label: `${language?.address || 'Address'}:`, value: currentResidency?.address || "" })
                },
                {
                    component: WrappedInputError,
                    name: 'AddressError',
                    renderIf: ({ isEditMode, currentResidency, selectedTabId }) => isEditMode && currentResidency?.addressError && selectedTabId !== 'review',
                    bindings: ({ currentResidency }) => ({ error: currentResidency?.addressError || ""})
                },
                {
                    component: WrappedGoogleSearchInput,
                    name: 'Location',
                    renderIf: ({ currentResidency, isEditMode }) => currentResidency?.address?.hasOwnProperty('address') && !isEditMode,
                    bindings: ({ currentResidency }) => {
                        return ({ resourceObj: currentResidency, label: '', value: currentResidency?.address?.address || "" })
                    }
                },
                {
                    component: WrappedInputError,
                    name: 'LocationError',
                    bindings: ({ currentResidency }) => ({error: currentResidency?.address?.addressError}),
                    renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency?.address?.addressError && selectedTabId !== 'review',
                },
                {
                    wrapper: Wrapper(styled.div`display: flex; flex-wrap: wrap`),
                    name: "AddressDetails",
                    renderIf: ({ isEditMode, currentResidency }) => {
                        const shouldshow = showAddressFields(currentResidency)
                        return shouldshow && !isEditMode
                    },
                    elements: [
                        {
                            component: WrappedInput,
                            name: 'City',
                            bindings: ({ currentResidency }) => {
                                return ({ currentResidency, label: 'City:', value: currentResidency?.address?.city || "" })
                            }
                        },
                        {
                            component: WrappedInputError,
                            name: 'CityError',
                            bindings: ({ currentResidency }) => ({error: currentResidency?.address?.cityError || ""}),
                            renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency?.address?.cityError && selectedTabId !== 'review',
                        },
                        {
                            component: WrappedDropdown,
                            name: 'State',
                            bindings: ({ currentResidency,  }) => {
                                return ({ search: true, currentResidency, label: 'State: ', selectedOptionId: currentResidency?.address?.state, options: US_STATES })
                            }
                        },
                        {
                            component: WrappedInputError,
                            name: 'StateError',
                            bindings: ({ currentResidency }) => ({error: currentResidency?.address?.stateError || ""}),
                            renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency?.address?.stateError && selectedTabId !== 'review',
                        },
                        {
                            component: WrappedInput,
                            name: 'Zip',
                            bindings: ({ currentResidency }) => ({ currentResidency, label: 'Zip:', value: currentResidency?.address?.zip || "" })
                        },
                        {
                            component: WrappedInputError,
                            name: 'ZipError',
                            bindings: ({ currentResidency }) => ({error: currentResidency?.address?.zipError || ""}),
                            renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency?.address?.zipError && selectedTabId !== 'review',
                        },
                    ]
                },
                {
                    component: WrappedInput,
                    name: 'Name',
                    bindings: ({ language, currentResidency }) => {
                        return ({ currentResidency, label: `${language?.landlord_name || 'Landlord/Property Name'}:`, value: currentResidency.name || '' })}
                },
                {
                    component: WrappedInput,
                    name: 'Number',
                    bindings: ({ language, currentResidency }) => {
                        return ({ currentResidency, label: `${language?.landlord_num || 'Landlord Number'}:`, value: currentResidency.number || '' })}
                },
                {
                    component: WrappedInputError,
                    name: 'NumberError',
                    bindings: ({ currentResidency }) => ({error: currentResidency.numberError}),
                    renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency.numberError && selectedTabId !== 'review',
                },
                {
                    component: WrappedInput,
                    name: 'Email',
                    bindings: ({ language, currentResidency }) => {
                        return ({ currentResidency, label: `${language?.landlord_email || 'Landlord Email'}:`, value: currentResidency.email || '' })}
                },
                {
                    component: WrappedInputError,
                    name: 'EmailError',
                    bindings: ({ currentResidency }) => ({error: currentResidency.emailError}),
                    renderIf: ({ currentResidency, selectedTabId }) => !!currentResidency.emailError && selectedTabId !== 'review',
                },
            ]
        },
    ],
}

const Landlord = Container(definition);

export default Landlord;
